import { Check, X } from "lucide-react";

const goodFit = [
  "You need more leads and pipeline but want marketing that reflects your brand truth",
  "You want a deployed system generating leads. Not another strategy deck that gathers dust",
  "You value the art of positioning and messaging as much as the science of automation",
  "You want to rank and be cited in AI answers (AI Overviews, AI Mode, ChatGPT, Perplexity)",
  "You're spending on SEO/PPC but can't attribute results to revenue, and want structured A/B testing to fix it",
  "You need a senior marketing partner who understands operations, gaps, and transformation",
];

const notFit = [
  "You want volume content without quality, brand alignment, or lead gen intent",
  "You want \"rankings only\" without caring about pipeline or conversion",
  "You need a low-cost junior team to execute someone else's strategy without questioning it",
  "You're not ready to invest in transformation, you want a quick fix without changing anything",
  "You don't care about your brand promise or authentic differentiation",
];

export default function FitSection() {
  return (
    <section id="fit" className="py-12 sm:py-16 lg:py-28 bg-[#F7F5F2]" aria-labelledby="fit-heading">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <div className="reveal text-center mb-12">
            <span className="text-mono text-[#FF8C00] block mb-4">Who We Serve</span>
            <h2 id="fit-heading" className="text-display text-3xl sm:text-4xl text-[#1A1A2E] mb-4">
              Who our AI marketing partnership is for
            </h2>
            <p className="text-[#6B7280] text-lg max-w-2xl mx-auto">
              We work best with B2B brands who value both the art and science of marketing -
              teams that want a mature partner who understands their operations, identifies the gaps,
              and deploys AI-powered lead generation while staying authentic to their brand promise.
            </p>
            <p className="text-[#6B7280] text-lg max-w-2xl mx-auto mt-3">
              B2C and e-commerce brands that want AI search visibility and paid media working as one system.
            </p>
          </div>

          <div className="reveal grid md:grid-cols-2 gap-6">
            {/* Good fit */}
            <div className="bg-white border border-[#10B981]/20 rounded-sm p-6 sm:p-8">
              <h3 className="text-[#10B981] font-semibold text-lg mb-5 flex items-center gap-2">
                <Check size={20} /> Good fit if
              </h3>
              <ul className="space-y-3">
                {goodFit.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-[#4B5563] text-sm">
                    <Check size={14} className="text-[#10B981] mt-1 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Not a fit */}
            <div className="bg-white border border-red-200 rounded-sm p-6 sm:p-8">
              <h3 className="text-red-500 font-semibold text-lg mb-5 flex items-center gap-2">
                <X size={20} /> Not a fit if
              </h3>
              <ul className="space-y-3">
                {notFit.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-[#4B5563] text-sm">
                    <X size={14} className="text-red-400 mt-1 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
